<template>
  <div class="flex flex-row page-con h-full">
    <!--  病人 start  -->
    <el-card class="flex flex-col h-full prescription-con">
      <el-select v-model="currentPositionId">
        <el-option
          v-for="position in positions"
          :key="position.id"
          :label="position.name"
          :value="position.id"
        />
      </el-select>
      <!--      病人 start    -->
      <med-prescriptions ref="patients" class="patients" />
      <!--      病人 end    -->
    </el-card>
    <!--  病人 end  -->
    <el-card class="flex flex-col list-con">
      <!--   方剂 start   -->
      <div class="mb-10">
        <model-header label="处方">
          <template #options>
            <el-button
              v-show="prescription.head.code"
              type="primary"
              size="small"
              @click="sendMed"
            >发药
            </el-button>
          </template>
        </model-header>
        <prescription-info />
      </div>
      <!--   方剂 end   -->
      <!--   出库清单 start   -->
      <div>
        <model-header label="出库清单" />
        <out-list />
      </div>
      <!--   出库清单 end   -->
    </el-card>
  </div>
</template>
<script>
import { findPage, postData } from "@/api/ik/data/dataApi"
import medPrescriptions from "@/views/business/page/settlement/takeMedicine/SendMedPrescriptions.vue"
import ModelHeader from "@/components/utils/ModelHeader.vue"
import PrescriptionInfo from "@/views/business/page/settlement/takeMedicine/PrescriptionInfo.vue"
import OutList from "@/views/business/page/settlement/takeMedicine/OutList.vue"

export default {
  name: "Index",
  components: { OutList, PrescriptionInfo, ModelHeader, medPrescriptions },
  data() {
    return {
      positions: [], // 药库列表
      currentPositionId: "", // 当前药库
      diagRecords: [], // 就诊记录
      prescription: {
        head: {
          positionName: "",
          serveFeeSign: "",
          doseNum: ""
        },
        body: {
          chmedPrescriptionItem: []
        }
      },
      outOrd: { // 出库单
        head: {},
        body: {
          outOrdItem: []
        }
      }
    }
  },
  provide() {
    return {
      pageData: this
    }
  },
  computed: {
    /**
     * 门店编码
     * @returns {any}
     */
    storeCode() {
      return this.$store.getters["user/getStoreCode"]
    }
  },
  mounted() {
    this.getPositions()
  },
  methods: {
    /**
     * 重置页面 数据
     */
    reset() {
      this.prescription = {
        head: {
          positionName: "",
          serveFeeSign: "",
          doseNum: ""
        },
        body: {
          chmedPrescriptionItem: []
        }
      }
      this.outOrd = { // 出库单
        head: {},
        body: {
          outOrdItem: []
        }
      }
    },
    /**
     * 确认发药
     */
    sendMed() {
      const pd = {
        code: this.prescription.head.code
      }
      postData("clinic/treatment/treatment/diagrecord/do/medsend", pd)
        .then(res => {
          this.$message.success("发药成功")
          this.$refs.patients.findDiagRecord()
          this.reset()
        })
    },
    /**
     * 获取药库列表
     */
    getPositions() {
      const url = "clinic/inventory/inventory/position"
      const pd = {
        storeCode: this.storeCode,
        positionSign: "1",
        classifySign: '1'
      }
      findPage(url, pd, 5, 1)
        .then(res => {
          this.positions = res.data.list
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.page-con {
  padding: 5px;
  // 处方
  .prescription-con {
    margin-right: 15px;
    width: 319px;
  }

  // 发药单
  .list-con {
    flex: 1;
    padding: 20px;
  }
}
</style>
